// extracted by mini-css-extract-plugin
export default {"content":"TenantPage_content__WP3Za"};